module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Base_02.b0a8b170.png";